import React, { PureComponent } from 'react'
import { Alert } from 'react-bootstrap'
import { connect } from 'react-redux'
import commonActions from '../../common.actions'

class CustomAlert extends PureComponent {

	constructor(props) {
		super(props)

		const type = props.content && props.content.type ? props.content.type : 'danger'
		const message = props.content && props.content.text ? props.content.text : 'Unknown error occured.'
		const uuidNumber = props.uuidNumber

		this.state = {
			type,
			message,
			uuidNumber
		}

		let timeout = 5000
		if (type === 'danger') {
			timeout = 20000;
		}

		setTimeout(() => {
			props.handleDismiss()
		}, timeout)
	}

	render() {
		const { message, type, uuidNumber } = this.state

		return (
			<Alert data-testid="alertCmp" onClose={this.props.handleDismiss} variant={type || 'warning'} className={'astm-alert bg-' + type + '--light'} closeLabel={''} dismissible>
				<div className='flex-box'>
					<span className="astm-alert-text">{message}</span>
					{ type === 'danger' && uuidNumber !== null && <span className="astm-alert-text text-end">Record ID: {uuidNumber}</span> }
				</div>
			</Alert>
		)
	}
}

// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({
})

const mapDispatchToProps = (dispatch) => ({
	handleDismiss: () => {
		dispatch(commonActions.setMessage(false, '200'))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomAlert)
